<template>
  <div>
    <div
      v-if="companyObj"
      class="caption d-flex flex-row flex-wrap justify-sm-space-between"
    >
      <div>
        <a href="/rgps/materials">All Materials </a> >
        <div class="d-inline-block">{{ companyObj.name }}</div>
      </div>

      <a
        v-if="companyObj.lensCount > 1"
        :href="'/rgps/company/' + companyObj.slug"
      >
        View {{ companyObj.name }}&apos;s LENSES
      </a>
    </div>
    <v-card class="blueCard pa-4" flat>
      <div class="d-flex flex-row flex-wrap align-start">
        <div class="d-flex flex row flex-wrap align-center">
          <!-- <div v-if="companyObj" class="d-flex flex-row flex-wrap align-center"> -->
          <div
            v-if="companyObj && companyObj.image"
            class="companyImage pt-2 pb-4 pl-4 pr-8"
          >
            <v-img
              :src="companyPath + companyObj.image"
              max-width="240"
              max-height="60"
              contain
              eager
              :alt="companyObj.name"
            ></v-img>
          </div>

          <!-- <div class="caption text-center">
              {{ companyObj.name }}
            </div> -->
          <!-- </div> -->

          <div v-else class="text-h5 mx-4 my-2 d-flex flex-row align-center">
            <div class="pr-2" style="width: 42px">
              <v-img
                :src="materialIconPath"
                max-width="30"
                max-height="30"
                contain
                eager
              ></v-img>
            </div>
            RGP Materials
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-btn-toggle
          v-model="groupBy"
          rounded
          class="my-2 my-sm-0 toggleBtns"
          active-class="activeToggle"
        >
          <v-btn x-small value="companyId" v-if="!companyObj"
            >Group by Company</v-btn
          >
          <v-btn x-small value="materialTypeId">Group by Type</v-btn>
          <v-btn x-small :value="null"
            ><v-icon x-small class="mr-2">mdi-format-list-text</v-icon
            >List</v-btn
          >
        </v-btn-toggle>
      </div>
      <div class="my-2 d-flex flex-row flex-wrap align-start">
        <div style="width: 300px">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Filter By Name"
            single-line
            hide-details
            outlined
            rounded
            dense
            clearable
            background-color="#FFF"
            class="compact-select"
            @blur="searchChange()"
            @keyup.enter="searchChange()"
          ></v-text-field>
        </div>
        <v-checkbox
          class="mb-sm-1 mr-4"
          v-model="filters.high_dk"
          :label="`Only high dk (>${highDkThreshold})`"
          hide-details="auto"
          dense
        ></v-checkbox>
      </div>
      <!-- {{ rgpOptions.lensCompanies }} -->
    </v-card>

    <v-data-table
      :loading="loading"
      :headers="headersForSize"
      :items="filteredMaterials"
      item-key="name"
      hide-default-footer
      :hide-default-header="isMobile"
      :items-per-page="-1"
      @click:row="rowClick"
      dense
      :group-by="groupBy"
      class="pointer mt-4 dTable"
    >
      <!-- <template v-slot:group.summary="{ isOpen }">
        <td :colspan="headers.length">{{ isOpen ? "" : "hi" }}</td>
      </template> -->
      <template v-slot:group.header="{ group, items, isOpen, toggle }">
        <td
          :colspan="headersForSize.length"
          style="
            background-color: rgb(239 247 250);
            border: 1px solid rgb(230 245 255);
            min-height: 55px;
          "
          @click="toggle"
        >
          <div class="d-flex flex-row" :class="{ viewWidth: isMobile }">
            <div class="title">
              <div v-if="groupBy == 'companyId'">
                {{
                  companyForItem(items[0]) ? companyForItem(items[0]) : " - "
                }}
              </div>
              <div v-if="groupBy == 'materialTypeId'">
                {{
                  materialTypeNameForId(items[0].materialTypeId)
                    ? materialTypeNameForId(items[0].materialTypeId)
                    : "Unknown"
                }}
              </div>
            </div>
            <v-spacer></v-spacer>
            <v-btn
              text
              icon
              small
              color="primary"
              class="ma-1"
              :ref="group"
              :data-open="isOpen"
            >
              <v-icon>{{
                isOpen ? "mdi-chevron-up" : "mdi-chevron-down"
              }}</v-icon>
            </v-btn>
          </div>
        </td>
      </template>

      <template v-slot:item.image="{ item }">
        <div class="imgCell">
          <v-img
            v-if="item.image"
            :src="imagePath + item.image"
            contain
            max-height="30"
            max-width="50"
          ></v-img>
        </div>
      </template>

      <template v-slot:item.name="{ item }">
        <div class="font-weight-bold">{{ item.name }}</div>
        <div v-if="item.generic_name" class="caption">
          {{ item.generic_name }}
        </div>
      </template>

      <template v-slot:item.dk="{ item }">
        {{ item.dk ? item.dk : " &nbsp;&nbsp; - " }}
      </template>
      <template v-slot:item.wetAngle="{ item }">
        {{ item.wetAngle ? item.wetAngle : " &nbsp;&nbsp; - " }}
      </template>
      <template v-slot:item.refractiveIndex="{ item }">
        {{ item.refractiveIndex ? item.refractiveIndex : " &nbsp;&nbsp; -  " }}
      </template>
      <template v-slot:item.specificGravity="{ item }">
        {{ item.specificGravity ? item.specificGravity : " &nbsp;&nbsp; -  " }}
      </template>

      <template v-slot:item.companyId="{ item }">
        {{ companyForItem(item) }}
      </template>

      <template v-slot:item.materialTypeId="{ item }">
        {{ materialTypeNameForId(item.materialTypeId) }}
      </template>

      <!-- for small screens -->
      <template v-slot:item.one="{ item }">
        <div class="text-left py-2">
          <div class="text-h5 ml-2">
            {{ item.name }}
            <span v-if="item.generic_name" class="caption ml-4">
              ({{ item.generic_name }})
            </span>
          </div>
          <!-- <v-divider></v-divider> -->
          <div class="ml-2">
            <table class="smTable">
              <tr v-if="companyForItem(item)">
                <th>Company</th>
                <td>{{ companyForItem(item) }}</td>
              </tr>
              <tr
                v-if="
                  materialTypeNameForId(item.materialTypeId) &&
                  materialTypeNameForId(item.materialTypeId) != 'unknown'
                "
              >
                <th>Type</th>
                <td>{{ materialTypeNameForId(item.materialTypeId) }}</td>
              </tr>
              <tr v-if="item.dk">
                <th>Properties</th>

                <td>
                  <div class="d-flex flex-row flex-wrap">
                    <div class="mr-3" v-if="item.dk">Dk: {{ item.dk }}</div>
                    <div class="mr-3" v-if="item.wetAngle">
                      Wetting Angle: {{ item.wetAngle }}
                    </div>
                    <div class="mr-3" v-if="item.refractiveIndex">
                      Refractive Index: {{ item.refractiveIndex }}
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </template>
    </v-data-table>

    <!-- {{ materials }} -->

    <v-dialog v-model="dialog" max-width="350" scrollable>
      <material-detail-card
        :materialData="selectedItem"
        :rgpOptions="rgpOptions"
        @close="dialog = false"
      ></material-detail-card>
    </v-dialog>
  </div>
</template>

<script>
// import Name from "../dir/file";
// import ApiServices from "@/services/ApiServices";
import RgpOptionsMixin from "@/assets/js/rgps/RgpOptionsMixin.js";
import FiltersMixin from "@/assets/js/cls/FiltersMixin";

export default {
  name: "RgpMaterials",
  props: {
    isAdmin: null,
    rgpOptions: null,
    materialList: null,
  },
  components: {
    MaterialDetailCard: () => import("@/components/gpStuff/MaterialDetailCard"),
  },
  mixins: [RgpOptionsMixin, FiltersMixin],
  data: function () {
    return {
      loading: false,
      search: "",
      dialog: false,
      materialCompany: null,
      selectedItem: null,
      highDkThreshold: 80,
      groupBy: null,
      imagePath: "https://www.eyedock.com/images/rgp_materials/",
      companyPath: "https://www.eyedock.com/images/rgp_companies/",
      materialIconPath:
        "https://eyedock.com/images/menu_icons/rgp_button_icon.svg",
      materials: [],
      meta: null,
      filters: { search: null, high_dk: null },
      headers: [
        { text: "", value: "image" },
        { text: "Name", value: "name" },
        { text: "Company", value: "companyId" },
        { text: "Type", value: "materialTypeId" },
        { text: "Dk", value: "dk" },
        { text: "Wet Angle", value: "wetAngle" },
        { text: "Index", value: "refractiveIndex" },
        { text: "Spec. Gravity", value: "specificGravity" },
      ],
      mobileHeader: [{ text: "Name", value: "one" }],
    };
  },
  methods: {
    rowClick(item) {
      // console.log(item);
      this.selectedItem = item;
      this.dialog = true;
    },
    //todo - put this in a mixin
    companyForItem(item) {
      let id = item.companyId;
      let companies = this.rgpOptions?.companies;
      if (!id || !companies) return null;
      return companies[id]?.name;
    },
    typeForItem(item) {
      let id = item?.materialTypeId;
      if (!id) return null;
      return this.materialTypeNameForId(id);
    },
    searchChange() {
      this.filters.search = this.search;
    },
  },
  computed: {
    isMobile: function () {
      return !this.$vuetify.breakpoint.smAndUp;
    },
    headersForSize: function () {
      return this.isMobile ? this.mobileHeader : this.headers;
    },
    filteredMaterials: function () {
      if (!this.materials) return [];
      let search = this.search;
      let high_dk = this.filters.high_dk;
      let highDkThreshold = this.highDkThreshold;
      let companyId = this.companyObj?.id;
      let itemsF = this.materials.filter((item) => {
        if (companyId && item.companyId != companyId) return false;
        if (search) {
          search = search.toLowerCase();
          let nameMatch = item.name.toLowerCase().includes(search);
          // console.log(search, item.name.toLowerCase(), nameMatch);
          let compMatch =
            item.companyName && item.companyName.toLowerCase().includes(search);
          let genericMatch =
            item.generic_name &&
            item.generic_name.toLowerCase().includes(search);
          if (!nameMatch && !compMatch && !genericMatch) return false;
        }
        if (high_dk) {
          if (!item.dk) return false;
          return parseInt(item.dk) >= highDkThreshold;
        }

        return true;
      });
      return itemsF;
    },
    companyObj: function () {
      return this.materialCompany
        ? this.companyObjForSlug(this.materialCompany)
        : null;
    },
  },
  watch: {
    materialList: {
      handler(val) {
        if (val && val.items) {
          this.loading = false;
          this.materials = val.items;
          this.meta = val.meta;
        }
      },
      deep: true,
    },
  },
  mounted() {
    // this.getMaterials();
    this.loading = true;
    this.$emit("getMaterialList");

    this.prepend_F = false; // (for FiltersMixin)
    this.keysCase = "lower"; // (for FiltersMixin)
    this.setFiltersFromHash();
    if (this.filters.search) this.search = this.filters.search;

    this.materialCompany = this.$route?.params?.materialCompany ?? null;
  },
  metaInfo() {
    return {
      title: "EyeDock/GPs | GP Materials",
    };
  },
};
</script>

<style scoped>
/* td {
  padding: 0 10px;
} */
/* .cellTitle {
  background-color: #eaf6fb;
  border-radius: 3px;
  padding-left: 1em;
} */
.viewWidth {
  min-width: 90vw;
}

.dTable >>> tbody tr:nth-of-type(odd) {
  background-color: #f0f9ff;
}
.smTable tr {
  background-color: transparent !important;
}
.smTable tr td {
  padding-left: 10px;
  font-weight: 300;
}
.smTable tr th {
  font-weight: 400;
  vertical-align: top;
}

.imgCell {
  width: 60px;
}
.companyPath {
  width: 250px;
}
.fakeBtn {
  height: 28px;
  min-width: 50px;
  padding: 0 12.44px;
  font-size: 0.75rem;
  display: inline-block;
  font-weight: 500;
  letter-spacing: 0.0892857143em;
  text-indent: 0.0892857143em;
  text-transform: uppercase;
}
</style>
